import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import _ from 'lodash';
import { useAtomValue } from 'jotai';
import { BASEURL, LISTURL } from './config';
import { Dashboard, Blank } from './views';
import {
  General,
  NotFound,
  UnAuthenticated,
  ReplyReviewList,
  ReplyQuestionList,
  ReviewList,
  ReviewImport,
  QuestionList,
  CustomerList,
  Setting,
  Documentation,
} from './pages';
import { authAtom } from './atoms/auth';

const PrivateRoute = ({ children }: { children: JSX.Element }): JSX.Element => {
  const auth = useAtomValue(authAtom);
  if (_.isNull(auth)) {
    return <Navigate to={LISTURL.unauthenticated} replace={true} />;
  }
  return children;
};

const Router = (): JSX.Element => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path={`/${BASEURL}/pages/`} element={<Blank />}>
          <Route path={LISTURL.not_found} element={<NotFound />} />
          <Route path={LISTURL.unauthenticated} element={<UnAuthenticated />} />
          <Route
            path=""
            element={<Navigate to={LISTURL.not_found} replace={true} />}
          />
        </Route>
        <Route
          path={`/${BASEURL}`}
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        >
          <Route path={LISTURL.general} element={<General />} />
          <Route path={LISTURL.customers} element={<CustomerList />} />
          <Route path={LISTURL.documentation} element={<Documentation />} />
          <Route path={LISTURL.reviews_import} element={<ReviewImport />} />
          <Route path={LISTURL.reviews_reply} element={<ReplyReviewList />} />
          <Route path={LISTURL.reviews_list} element={<ReviewList />} />
          <Route
            path={LISTURL.question_reply}
            element={<ReplyQuestionList />}
          />
          <Route path={LISTURL.question_list} element={<QuestionList />} />
          <Route path={LISTURL.settings} element={<Setting />} />
          <Route
            path=""
            element={<Navigate to={LISTURL.general} replace={true} />}
          />
        </Route>
        <Route
          path="/"
          element={<Navigate to={LISTURL.general} replace={true} />}
        />
        <Route
          path="*"
          element={<Navigate to={LISTURL.not_found} replace={true} />}
        />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
